import PropTypes from 'prop-types';
import { loadSavedListDetails } from '@app/store/account/actions';
import { STATUS } from '@app/constants/commonConstants';
import {
  AlloyButton,
  ListManager,
  listStrategy,
  ComponentLoader
} from 'cat-ecommerce-alloy';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import ExceptionFeedback from '../../Exception/ExceptionFeedback';
import TableStructure from './TableStructure';
import styles from './SavedListContainer.module.scss';
import Conditional from '../../Conditional/Conditional';

const SavedListContainer = ({ close, handleOpenChild, filteredLists }) => {
  const [t] = useTranslation();
  const dispatch = useDispatch();
  const DEFAULT_DISPLAYED_LISTS = 6;

  const savedListsStatus = useSelector(s => s.account?.savedListsStatus);
  const savedListItemImportStatus = useSelector(
    s => s.savedListDetailUI?.status
  );

  const isLoadingSavedListItemStatus =
    savedListItemImportStatus === STATUS.PENDING ||
    savedListsStatus === STATUS.PENDING;

  const isErrorLoadingSavedLists = savedListsStatus === STATUS.REJECTED;

  if (isErrorLoadingSavedLists) {
    return (
      <ExceptionFeedback title={t('UNKNOWN_ERROR_TITLE')} className="mb-5">
        <p>{t('UNKNOWN_ERROR_MESSAGE')}</p>
        <AlloyButton
          buttonType="secondary"
          className="mb-3 me-3"
          onClick={() => dispatch(loadSavedListDetails())}
        >
          {t('TRY_AGAIN')}
        </AlloyButton>
      </ExceptionFeedback>
    );
  }

  const emptyListMessage = () => (
    <div className="d-flex flex-column align-items-center mt-4 mb-3">
      <img
        alt="Search"
        loading="lazy"
        width={144}
        height={96}
        src="https://caterpillar.scene7.com/is/image/Caterpillar/CM20220110-42177-9cddb"
      />
      <p className="mb-3">{t('NO_SAVED_LISTS')}</p>
      <AlloyButton buttonType="ghost" onClick={handleOpenChild}>
        {t('SL_CREATE_LIST')}
      </AlloyButton>
    </div>
  );

  return (
    <>
      {isLoadingSavedListItemStatus && (
        <ComponentLoader contentClassName="position-sticky" />
      )}
      <Conditional
        test={filteredLists.length > 0}
        fallback={emptyListMessage()}
      >
        <div className={styles['saved-list-modal__table']}>
          <ListManager
            strategy={listStrategy.CLIENT_SIDE}
            list={filteredLists}
            sortBy="updated"
            sortDirection={-1}
            itemsPerPage={DEFAULT_DISPLAYED_LISTS}
          >
            <TableStructure close={close} listsLength={filteredLists.length} />
          </ListManager>
        </div>
      </Conditional>
    </>
  );
};

export default SavedListContainer;

SavedListContainer.propTypes = {
  close: PropTypes.func,
  filteredLists: PropTypes.array,
  handleOpenChild: PropTypes.func
};
